import TwoFactorLogin from 'modules/auth/twoFactor'
import React from 'react'

export default function WithJwtPage() {
    return <TwoFactorLogin />
}
